import React from 'react';
import { STRIPE_PAYMENT_LINK } from '../config';
import './Hero.css';

function Hero() {
  return (
    <>
      <section className="hero" id="books">
        <div className="hero-scene">
          <div className="flag-layer">
            <img src="/images/hero-flag.webp" alt="" />
          </div>
          <div className="atmosphere"></div>
          <div className="beam"></div>
          <div className="beam2"></div>
          <div className="grain"></div>
        </div>

        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-stripe"></div>
            <p className="hero-tagline">A Political Thriller</p>
            <h1 className="hero-title">SAVING<br />GRACE</h1>
            <p className="hero-byline">A Novel by Atiba</p>
            <p className="hero-pitch">
              <strong>After surviving a violent abduction,</strong> Anthony Grace wakes in a hospital remembering nothing but the calm, commanding voice of one of his captors. Now, trying to reclaim his life, Anthony must expose the voice connected to a rising political star — before they bury him for good.
            </p>
            <div className="hero-ctas">
              <a href="#signup" className="btn-red">Get the Free Chapter</a>
              <a href={STRIPE_PAYMENT_LINK} className="btn-outline" target="_blank" rel="noopener noreferrer">Buy Now</a>
            </div>
          </div>
          <div className="hero-book">
            <img src="/images/book-cover.png" alt="Saving Grace book cover" />
          </div>
        </div>
      </section>
      <div className="stripe-divider"></div>
    </>
  );
}

export default Hero;
